import React, { Component } from "react";
import { conditionalWidth, imageAddress, translate } from "../../utils/useful";
import Modal from "../../components/Modal";
import FixedView from "../../components/FixedView";


class RoomHubsListSingleHub extends Component {

    state = {

        isOpen: false,
        hubsMore: [
            { title: 'Mute', icon: '/assets/icons/rooms/hubs/mute.svg', key: 'mute' },
            { title: 'Keek', icon: '/assets/icons/rooms/hubs/keek.svg', key: 'keek' },
        ]
    }



    componentDidMount() {

    }


    open = () => {

        this.setState({ isOpen: true })
    }

    close = () => {

        this.setState({ isOpen: false })
    }

    toggle = (cb) => {
        // console.log('toggle')
        this.setState({ isOpen: !this.state.isOpen }, () => {
            if (cb) {
                cb()
            }
        })

    }

    showAddPeopleModal = () => {

        this.addPeopleModal.showModal()
    }



    showOptions = (index) => {

        this.personFixedView.showView()
    }




    render() {

        return (
            <>

                <div className="unSelectMember flexc flex-column my-2 py-1" >
                    <div className={" w-100 flexcb "}>
                        <div className={" flexc cursor-pointer "} onClick={() => this.setState({ currentMember: this.props.hub })} style={{}}>
                            <img src={imageAddress(this.props.hub?.peer_image, 'hub', 'mini')} width={30} height={30} className="mrd-3 br-20 image-cover" alt="" />
                            <p className="font-size-14 weight-500 cursor-pointer" style={{ color: '#4F5B67' }}>{this.props.hub?.peer_name}</p>
                        </div>
                        <button className="flexcc" onClick={() => { this.showOptions() }} ref={e => this.personNodeRef = e} >
                            <img width={24} className={" invert opacity-5 "} src='/assets/icons/rooms/more.svg' alt="" />
                        </button>
                    </div>
                    <FixedView ref={el => this.personFixedView = el} nodeRef={this.personNodeRef} zIndex={1000} bottomOffset={10} topOffset={0} maxWidth={120} width={120} >
                        <div className='sc-1 shadow-2 br-10 py-1 px-2 w-100' style={{ backgroundColor: "#fff", }}>
                            {this.state.hubsMore.map((prop, index) => {
                                return (
                                    <div className="bb-gray pb-1">
                                        <div className="flexc w-100 optionMember pt-1" style={{ zIndex: 100 }}>
                                            <button className="flexc">
                                                <img src='/assets/icons/rooms/microphone-off-red.svg' className="mrd-2" alt="" />
                                                <p style={{ color: '#DB302A' }}>{translate(prop.title)}</p>
                                            </button>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </FixedView>
                </div>
            </>
        )
    }


}
export default RoomHubsListSingleHub